import React from 'react';
import * as S from './cancel-anytime-block.molecule.style';
import { GiCheckMark } from 'react-icons/gi';
import { Checkout } from '../../../common/types/checkout';
import { useTranslation } from 'react-i18next';

type Props = {
  checkout: Checkout;
};

export const CancelAnytimeBlock: React.FC<Props> = ({ checkout }) => {
  const { t } = useTranslation();
  const shouldShowCancelAnytime = !!checkout?.recorrencia;
  if (!shouldShowCancelAnytime) return null;
  return (
    <S.SubscriptionTrustRow>
      <S.TrustIcon>
        <GiCheckMark />
      </S.TrustIcon>

      <S.TrustText aria-hidden>
        <span className="phrase">{t('cancelAnytime')}</span>
        <span className="sep">•</span>
        <span className="phrase">{t('noCommitment')}</span>
        <span className="sep">•</span>
        <span className="phrase">{t('secureBilling')}</span>
        <span className="sep">•</span>
        <span className="phrase">{t('emailReminder')}</span>
      </S.TrustText>
    </S.SubscriptionTrustRow>
  );
};
